import { render, staticRenderFns } from "./66.vue?vue&type=template&id=4e348cb2&scoped=true&"
var script = {}
import style0 from "./66.vue?vue&type=style&index=0&id=4e348cb2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e348cb2",
  null
  
)

export default component.exports